/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { getClientes } from '../../services/ClientServices/getClientService'
import { useFiltrosCatalogo } from '../../hooks/useFiltrosCatalogo'

export const useClientes = () => {
  const { segmentos, carregandoCatalogo } = useFiltrosCatalogo({
    comCategorias: false,
  })
  const navigate = useNavigate()
  // Mesma forma de /produtos/:id: a lista entrega o detalhe sob o proprio segmento, para o menu
  // lateral marcar Clientes e o voltar devolver para a lista.
  const goToPage = (id: number) => {
    navigate(`/clientes/${id}`)
  }

  const [searchValue, setSearchValue] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [clientes, setClientes] = useState<GetProductsType>(
    {} as GetProductsType
  )
  const [isLoading, setIsLoading] = useState(true)

  const [statusChecked, setStatusChecked] = useState<string[]>([])
  const [statusCheckedTodos, setStatusCheckedTodos] = useState<string[]>([])
  const [statusCheckedFiltro, setStatusCheckedFiltro] = useState<string[]>([])

  // Segmento selecionado no painel x segmento realmente aplicado na busca (botao "Aplicar"),
  // mesmo par usado nos demais filtros da tela de Predicao.
  const [valueSegmento, setValueSegmento] = useState<string[]>([])
  const [segmentoFiltrado, setSegmentoFiltrado] = useState<string[]>([])
  const [isShowSegmento, setIsShowSegmento] = useState(false)

  const fetchClientes = async (cancel?: any) => {
    setIsLoading(true)
    const result = await getClientes(
      cancel,
      searchValue,
      statusCheckedFiltro,
      currentPage,
      segmentoFiltrado
    )
    setIsLoading(false)
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setClientes(result)
    }
  }
  const showFilter = () => {
    setIsShowSegmento(false)
    setIsShowFilter(!isShowFilter)
  }

  const showSegmentoFilter = () => {
    setIsShowFilter(false)
    setIsShowSegmento(!isShowSegmento)
  }

  const aplicarSegmento = () => {
    setSegmentoFiltrado(valueSegmento)
    // Volta para a primeira pagina: manter a pagina atual poderia cair fora do novo total.
    setCurrentPage(1)
    setIsShowSegmento(false)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const source = axios.CancelToken.source()
      fetchClientes(source)
      return () => {
        source.cancel('cancelToken')
      }
    }
  }

  const handleCheckboxChange = (option: string) => {
    if (option === 'TODOS') {
      if (statusChecked.includes('TODOS')) {
        setStatusChecked([])
      } else {
        setStatusChecked([])
        setStatusCheckedTodos([])

        localStorage.setItem('filtroStatus', JSON.stringify([]))
      }
    } else if (statusChecked.includes('TODOS')) {
      setStatusChecked([option])
    } else if (statusChecked.includes(option)) {
      setStatusChecked(statusChecked.filter(item => item !== option))

      statusChecked.length === 1
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])

      localStorage.setItem(
        'filtroStatus',
        JSON.stringify(statusChecked.filter(item => item !== option))
      )
    } else {
      setStatusChecked([...statusChecked, option])
      setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify([...statusChecked, option])
      )
    }
  }

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchClientes(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [currentPage, statusCheckedFiltro, JSON.stringify(segmentoFiltrado)])

  return {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    clientes,
    fetchClientes,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    handleCheckboxChange,

    segmentos,
    carregandoCatalogo,
    valueSegmento,
    setValueSegmento,
    segmentoFiltrado,
    isShowSegmento,
    showSegmentoFilter,
    aplicarSegmento,
  }
}
